import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./styles/index.css";

/**
 * 엔트리.
 *
 * `#root` 가 없으면 **조용히 빈 화면이 되는 대신 던집니다** — 로그인 화면이 아무것도 렌더하지 않는
 * 증상은 원인을 찾는 데 시간이 오래 걸립니다. 셸(`index.html`)이 바뀌었다는 뜻이므로 즉시 드러냅니다.
 */
const container = document.getElementById("root");
if (!container) throw new Error("#root 가 없습니다 — index.html 의 앱 마운트 지점을 확인하세요.");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
